const TE = r => require.ensure([], () => r(require('@/page/TE')), 'TE');

export default [
  {
    path: '/TE',
    name: 'TE',
    component: TE
  }
];



// WEBPACK FOOTER //
// ./src/router/TE.js